import BaseApiService from "../base_api.service";
import { TableModel, CreateTableModel } from "./models/tabele.model";

export class TableService extends BaseApiService {
  /**
   *
   */
  constructor() {
    super("Tables");
  }

  async getListByCompanyId(companyId: string): Promise<TableModel[]> {
    const dddd = await this.get<TableModel[]>(
      `/GetTableListByCompanyId?companyId=${companyId}`,
    );

    return dddd ?? [];
  }
  add(tableModel: CreateTableModel): Promise<TableModel | undefined> {
    console.error(tableModel);

    return this.post<TableModel>(``, tableModel);
  }
  update(tableModel: TableModel): Promise<TableModel | undefined> {
    return this.put<TableModel>(``, tableModel);
  }
  getById(id: string): Promise<TableModel | undefined> {
    return this.get<TableModel>(`/GetTableById?id=${id}`);
  }
  deleteById(id: string): Promise<string | undefined> {
    return this.delete<string>(`?id=${id}`);
  }
}
